import { useState } from "react"
import LayoutPage from "../../Components/LayoutPage"
import Buttons from "./Components/Buttons"
import Main from "./Components/Main"
export default function Challenge() {
  const [modalClosed, setModalClosed] = useState(false)
  return (
    <LayoutPage activeIndex={3} navItems={["حساب‌ها و چالش‌ها"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5">
      <Buttons setModalClosed={setModalClosed}/>
      <Main modalClosed={modalClosed} setModalClosed={setModalClosed}/>
    </LayoutPage>
  )
}